import { render, staticRenderFns } from "./CredentialGuide.vue?vue&type=template&id=dee6f37e&scoped=true"
import script from "./CredentialGuide.vue?vue&type=script&lang=js"
export * from "./CredentialGuide.vue?vue&type=script&lang=js"
import style0 from "./CredentialGuide.vue?vue&type=style&index=0&id=dee6f37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee6f37e",
  null
  
)

export default component.exports